import BarItemScore from './barItemScore';

export default function BarItem({ 
  title,
  score,
  lines,
  maxScore,
  formattedScore,
  color,
  label,
  alignBarTitle
}) {
  const hasValidLines = lines?.some(line => line.score);
  const hasValidScore = !!score;

  if (!hasValidLines && !hasValidScore) return null;
  return (
    <li>
      <span className={`scores-title ${alignBarTitle}`} dangerouslySetInnerHTML={{ __html: title }}/>
      <span className="scores-score-wrapper">
        {hasValidLines ? (
          <ul className="score-lines">
            {lines.map((line, index) => 
              line.score ? (
                <li key={index}>
                  <BarItemScore 
                    score={line.score}
                    maxScore={maxScore}
                    formattedScore={line.formattedScore}
                    color={line.color}
                    label={label}
                  />
                </li>
              ) : null
            )}
          </ul>
        ) : (
          <BarItemScore 
            score={score}
            maxScore={maxScore}
            formattedScore={formattedScore}
            color={color}
            label={label}
          />
        )}
      </span>
    </li>
  );
};
